import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService';
import type { DocVStatus } from '@Store/slices/ubo/createUboSlice';

export interface CompleteUboPayload {
  setPasswordData: { password: string };
  token: string;
}

export interface CompleteUboRequest {
  customerId: string;
  payload: CompleteUboPayload;
}

export interface CompleteUboResponse {
  onboardingStatus: string;
  docVStatus: DocVStatus;
  token: string | null;
  url?: string;
  qrCode?: string;
}

export const completeUbo = async (request: CompleteUboRequest) => {
  const { customerId, payload } = request;

  const url = `v4/onboarding/secondary/${customerId}/complete`;

  const response = await HttpService.post<CompleteUboResponse>(url, payload);
  return response.data;
};

export interface UseCompleteUboParams extends Omit<
  UseMutationOptions<CompleteUboResponse, Error, CompleteUboPayload>,
  'mutationFn'
> {
  customerId: string;
}

export const useCompleteUbo = (params: UseCompleteUboParams) => {
  const { customerId, ...mutationOptions } = params;

  return useMutation({
    mutationFn: (payload: CompleteUboPayload) => completeUbo({ customerId, payload }),
    ...mutationOptions,
  });
};
